import type { GATriggerProps } from "@similarweb/ga-connect";
import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import Sentry from "@similarweb/sentry-logger";
import { Flex } from "@similarweb/ui-components/foundations";

import { useToasts } from "app/common/hooks";

export const useBoundaryErrorHandler = () => {
    const { translate } = useTranslate();
    const { showErrorToast } = useToasts();

    const boundaryErrorHandler: GATriggerProps["onBoundaryError"] = (error, info) => {
        Sentry.errorTracker({
            message: "GA Connect onBoundaryError",
            e: error,
            level: "error",
            params: {
                extra: {
                    info,
                },
            },
        });

        showErrorToast(
            <Flex
                gap="8px"
                alignItems="center"
            >
                <SWReactIcons
                    iconName="error-info"
                    size="sm"
                />
                {translate("common.error")}
            </Flex>,
        );
    };

    return boundaryErrorHandler;
};
